import { render, staticRenderFns } from "./ReadOnlyView.vue?vue&type=template&id=1723fa36&scoped=true&"
import script from "./ReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723fa36",
  null
  
)

export default component.exports